import React from 'react';
import { col_image,col_large } from "../../Fonctions.js";
import petitprince from '../../Resources/pictogrammes/cdpp-jaune.svg';
import vars from "../../files/vars.json"
import condor from "../../Resources/rhucondor.png";

function Description({className}) {
    return (
        <section className={`bandeau ${className}`}>
    <div className='row'>
        <div className={`col-xs-12 ${col_image}`}>
            <img id="img_petitprince" className="img-fluid" src={petitprince} alt='Logo Petit Prince' />
        </div>
        <div className={`col-xs-12 ${col_large}`}>
            <div className='testgrid'>
            <h1>La Course du Petit Prince </h1>
            <p>
                Créée en 2022, la course du Petit Prince (CdPP) est un événement caritatif organisé dans la forêt du Bourgailh, à Pessac (33).
            </p>
            <p>
                Cet événement propose des marches et des courses pédestres enfants (6-15 ans) et adultes sur un circuit 100% nature.
            </p>
            <p>
                Les dons des partenaires et les inscriptions payantes sont reversés intégralement au :
            </p>
            <h2>
                Programme de recherche national RHU CONDOR sur les sarcomes (Institut Bergonié)
            </h2>
                <a target="_blank" rel="noopener noreferrer" href={vars.url_condor}>
                    <img id="condor" className="img-fluid mt-2" src={condor} alt="Logo Condor" />
                </a>
        </div>
    </div>
    </div>
</section>


)}

export default Description;